import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { useScrollRestoration } from '../hooks/useScrollRestoration';

interface ScrollRestorationContextType {
  containerRef: React.RefObject<HTMLDivElement>;
  saveScrollBeforeNavigation: () => void;
  registerScrollRef: (ref: React.RefObject<HTMLDivElement> | null) => void;
  peekRestoreOffset: () => number | null;
  markRestored: () => void;
}

const ScrollRestorationContext = createContext<ScrollRestorationContextType | null>(null);

interface ScrollRestorationProviderProps {
  children: ReactNode;
  viewId: number;
}

export const ScrollRestorationProvider: React.FC<ScrollRestorationProviderProps> = ({ children, viewId }) => {
  const { containerRef, saveScrollBeforeNavigation, registerScrollRef, peekRestoreOffset, markRestored } =
    useScrollRestoration(viewId);

  const value = useMemo(
    () => ({ containerRef, saveScrollBeforeNavigation, registerScrollRef, peekRestoreOffset, markRestored }),
    [saveScrollBeforeNavigation, registerScrollRef, peekRestoreOffset, markRestored]
  );

  return (
    <ScrollRestorationContext.Provider value={value}>
      {children}
    </ScrollRestorationContext.Provider>
  );
};

export const useScrollRestorationContext = () => {
  const context = useContext(ScrollRestorationContext);
  return context;
};
